export default "__VITE_ASSET__6aa9c631__"